import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles/Faq.css";

import questions from "../config/faqConfig.json";

const Faq = () => {
  const { t } = useTranslation();
  const [openQuestions, setOpenQuestions] = useState({});

  const toggleQuestion = (id) => {
    setOpenQuestions((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <main className="faq">
      <h1>{t("faq.title")}</h1>

      <div className="faq-container">
        {questions.map(({ id, questionKey, answerKey }) => (
          <div key={id} onClick={() => toggleQuestion(id)}>
            <div className="faq-question">
              {t(questionKey)}
              <span>{openQuestions[id] ? "-" : "+"}</span>
            </div>

            {openQuestions[id] && <div className="faq-answer">{t(answerKey)}</div>}
          </div>
        ))}
      </div>
    </main>
  );
};

export default Faq;
